<template>
	<div class="tags">
		<div v-for="tag in tags" class="tag">
			{{ tag }}
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'value'
  ],
  computed: {
    tags: {
      get () {
        return this.value ? typeof this.value === 'string' ? JSON.parse(this.value) : this.value : []
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
